import script from "./LockedFunds.vue?vue&type=script&lang=ts&setup=true"
export * from "./LockedFunds.vue?vue&type=script&lang=ts&setup=true"

import "./LockedFunds.vue?vue&type=style&index=0&id=274b7bbf&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-274b7bbf"]])

export default __exports__